export default {"src":"/_next/static/media/phone-icon.60499af9.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};